function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.date.to-iso-string.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.date.now.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { faker } from '@faker-js/faker';
import { addDays, subDays } from 'date-fns';
import { rest } from 'msw';
import { SmartDeadlineTypes, TaskSchema, TaskType } from "./tasks";
var applications = Array.from({
  length: 12
}).map(function () {
  return {
    id: faker.string.nanoid(8),
    legacyId: faker.string.numeric(8),
    paid: faker.datatype["boolean"](),
    deadline: faker.date.between({
      from: subDays(new Date(), 10),
      to: addDays(new Date(), 60)
    }).toISOString(),
    intake: faker.helpers.arrayElement(['2023-09-01', '2024-03-01', '2024-06-01', '2024-09-01', '2025-03-01', '2025-06-01', '2025-09-01']),
    stageId: faker.helpers.arrayElement(['pre-payment', 'pre-submission', 'submission', 'admission', 'visa-application', 'pre-arrival', 'post-arrival', 'arrival'])
  };
});
var students = Array.from({
  length: 8
}).map(function () {
  return {
    studentId: faker.string.numeric(8),
    studentName: faker.person.fullName(),
    studentEmail: faker.internet.email()
  };
});
var rps = Array.from({
  length: 4
}).map(function () {
  return {
    rpId: faker.string.numeric(8),
    rpName: faker.person.fullName(),
    rpEmail: faker.internet.email()
  };
});
function buildTask() {
  var isSmartDeadlineNull = faker.helpers.arrayElement([true, false]);
  return {
    id: faker.string.nanoid(),
    title: faker.lorem.sentences({
      min: 1,
      max: 3
    }),
    type: faker.helpers.arrayElement(Object.values(TaskType)),
    status: faker.helpers.arrayElement(['COMPLETED', 'OUTSTANDING']),
    requirementId: faker.string.numeric(8),
    schoolName: "".concat(faker.location.country(), " University"),
    schoolCountry: faker.helpers.arrayElement(['Canada', 'Ireland', 'Australia', 'United Kingdom', 'United States']),
    smartDeadline: isSmartDeadlineNull ? null : faker.helpers.arrayElement([faker.date.between({
      from: subDays(new Date(), 10),
      to: addDays(new Date(), 60)
    }).toISOString()]),
    smartDeadlineType: isSmartDeadlineNull ? null : faker.helpers.arrayElement([SmartDeadlineTypes['Appointed'], SmartDeadlineTypes['Estimated']]),
    application: _objectSpread(_objectSpread(_objectSpread({}, faker.helpers.arrayElement(applications)), faker.helpers.arrayElement(students)), faker.helpers.arrayElement(rps))
  };
}
export function buildTasks() {
  var numberOfTasks = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 50;
  var tasks = [];
  for (var index = 0; index < numberOfTasks; index++) {
    tasks.push(buildTask());
  }
  return tasks;
}
export function mockTasks(numberOfTasks) {
  return rest.get('/api/rpj/v1/tasks', function (req, res, ctx) {
    return res(ctx.json(buildTasks(numberOfTasks)));
  });
}
function createTestJwt() {
  var header = {
    alg: 'none',
    typ: 'JWT'
  };
  var payload = {
    email: 'test.user@applyboard.com',
    role: 'test'
  };
  var base64Header = Buffer.from(JSON.stringify(header)).toString('base64').replace(/=/g, '');
  var base64Payload = Buffer.from(JSON.stringify(payload)).toString('base64').replace(/=/g, '');
  return "".concat(base64Header, ".").concat(base64Payload, ".");
}
export function mockApiToken() {
  return rest.get('/api/v2/tokens', function (_req, res, ctx) {
    return res(ctx.json({
      data: {
        attributes: {
          access_token: 'test-token',
          id_token: createTestJwt(),
          expires_at: Math.floor(Date.now() / 1000) + 600
        }
      }
    }));
  });
}
function buildParsedTask() {
  return TaskSchema.parse(buildTask());
}
export function buildParsedTasks() {
  var numberOfTasks = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 50;
  var tasks = [];
  for (var index = 0; index < numberOfTasks; index++) {
    tasks.push(buildParsedTask());
  }
  return tasks;
}